import { getTheme, themed, Box, Text as Tx, } from "@bracket/ui";
import styled from "styled-components";


export declare type BadgeProps = {
  color: "normal" | "primary";
  itemsCount: number;
};

export const Badge: React.FC<BadgeProps> = ({ color = "normal", itemsCount, }) => {
	themed();

	return (
    <BadgeContainer>
      <NotificationBadge $color={color}>
        <Tx xxsm color={color === "primary" ? getTheme().surface : getTheme().heading}>{itemsCount}</Tx>
      </NotificationBadge>
    </BadgeContainer>
  );
};


const BadgeContainer = styled(Box)``;

const NotificationBadge = styled(Box)<{ $color: BadgeProps["color"] }>`
  background: ${({ $color }) => $color === "primary" ? getTheme().primary : getTheme().surface_container_highest};
  border-radius: 50%;
  min-width: 1.25rem;
  height: 1.25rem;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
`;
